"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CryptoOrgErrorBroadcasting = exports.CryptoOrgSignatureSize = exports.CryptoOrgWrongSignatureHeader = void 0;
const errors_1 = require("@ledgerhq/errors");
exports.CryptoOrgWrongSignatureHeader = (0, errors_1.createCustomErrorClass)("CryptoOrgWrongSignatureHeader");
exports.CryptoOrgSignatureSize = (0, errors_1.createCustomErrorClass)("CryptoOrgSignatureSize");
exports.CryptoOrgErrorBroadcasting = (0, errors_1.createCustomErrorClass)("CryptoOrgErrorBroadcasting");
//# sourceMappingURL=errors.js.map